<template>
    <div class="uk-grid-medium uk-child-width-1-1"
         uk-grid>

        <!-- Show Settings -->
        <slot name="show-settings"></slot>
        <!-- Filters & Items -->
        <div>
            <div class="uk-grid-medium uk-child-width-1-1"
                 uk-grid>

                <!-- Show Settings -->
                <div>

                    <div class="uk-grid-small uk-child-width-auto@s uk-flex-between@s tm-show-settings" uk-grid>

                        <!-- выбранные фильтры -->
                        <slot name="selected-filters"></slot>

                        <!--

                                            &lt;!&ndash; Результатов на странице &ndash;&gt;


                                            &lt;!&ndash; Сортировка &ndash;&gt;

                        -->

                    </div>

                </div>

                <!-- Filters & Items -->
                <div>
                    <div class="uk-grid-medium"
                         uk-grid>

                        <slot name="shop-filters"></slot>
                        <!-- Items -->
                        <div class="uk-width-1-1 uk-width-expand@m">

                            <div class="uk-grid-medium uk-child-width-1-1"
                                 uk-grid>

                                 <!-- Pagination -->
                                 <shop-items-pagination
                                         :total-pages="ShopItems.total_pages"
                                         :last-page="ShopItems.last"
                                         :current-page="ShopItems.current"
                                         :next-page="ShopItems.next"
                                         :previous-page="ShopItems.before"
                                         v-on="$listeners"
                                 ></shop-items-pagination>

                                <!-- Cards -->
                                <div>
                                    <div class="uk-grid-medium uk-grid-match uk-child-width-1-3@m"
                                         uk-grid>
                                        <product v-for="Product in ShopItems.items" :key="Product.ShopItem.id"
                                                 :shop-item="Product.ShopItem"
                                                 :image="Product.Asset !== undefined ? Product.Asset : Product.ShopItem.image"
                                                 :shop-product="Product.ShopProduct"
                                                 :shop-item-prices="ShopItemPrices[Product.ShopItem.id]"
                                                 :related-shop-items="ShopItemsRelated[Product.ShopItem.id]"
                                                 :shop-item-properties="ShopItemProperties[Product.ShopItem.id]"
                                                 :shop-item-warehouses="ShopItemWarehouses[Product.ShopItem.id]"
                                                 :shop-item-tags="ShopItemTags[Product.ShopItem.id]"
                                                 :shop-order-item="ShopOrderItems[Product.ShopItem.id]"
                                                 v-on="$listeners"
                                        ></product>

                                    </div>
                                </div>

                                <!-- Pagination -->
                                <shop-items-pagination
                                        :total-pages="ShopItems.total_pages"
                                        :last-page="ShopItems.last"
                                        :current-page="ShopItems.current"
                                        :next-page="ShopItems.next"
                                        :previous-page="ShopItems.before"
                                        v-on="$listeners"
                                ></shop-items-pagination>

                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>

        <a class="uk-button uk-button-primary" id="js-scroll" style="margin-left: 20px;"></a>
    </div>
</template>

<script>
    import Product from './Product/Product'
    import ShopItemsPagination from "./ShopItemsPagination";


    export default {
        name: "ShopProducts",
        components: {
            ShopItemsPagination,
            Product
        },
        props: {
            ShopItems: {
                type: Object,
                default() {
                    return {}
                }
            },
            ShopItemPrices: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemsRelated: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemProperties: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemWarehouses: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemTags: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopOrderItems: {
                type: [Array, Object],
                default() {
                    return []
                }
            }
        },
        methods: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ShopProducts.vue?3c90f140